export const APP_NAME = "RIVETAI";

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOT_PATH = "";

export const PATH_DASHBOARD = {
  /** App home — must be `/`, not `""` (empty navigate() stays on the current route). */
  home: path(ROOT_PATH, "/"),
  dashboard: path(ROOT_PATH, "/"),
  onboarding: path(ROOT_PATH, "/onboarding"),
  archive: path(ROOT_PATH, "/archive"),
  settings: path(ROOT_PATH, "/settings"),
  billing: path(ROOT_PATH, "/settings/billing"),
  referrals: path(ROOT_PATH, "/settings/referrals"),
  notifications: path(ROOT_PATH, "/settings/notifications"),
  upgrade: path(ROOT_PATH, "/upgrade"),
  selectPlan: path(ROOT_PATH, "/plans"),
  activateAccount: path(ROOT_PATH, "/activate-account"),
  payments: path(ROOT_PATH, "/payment"),
  createProject: path(ROOT_PATH, "/projects/create"), // Legacy - will be replaced by workspace-based URLs
  uniqueProject: path(ROOT_PATH, "/projects/:id"), // Legacy - will be replaced by workspace-based URLs
  joinWorkspace: path(ROOT_PATH, "/join/:token"),
};

// Workspace-first URL structure
export const PATH_WORKSPACE = {
  workspace: "/workspaces/:workspaceId",
  workspaceSettings: "/workspaces/:workspaceId/settings",
  workspaceMembers: "/workspaces/:workspaceId/settings/members",
  workspaceBilling: "/workspaces/:workspaceId/settings/billing",
  workspaceProjects: "/workspaces/:workspaceId/projects",
  workspaceProject: "/workspaces/:workspaceId/projects/:projectId",
};

export const PATH_AUTH = {
  register: path(ROOT_PATH, "/register"), // legacy alias
  signup: path(ROOT_PATH, "/signup"),
  ssoLogin: path(ROOT_PATH, "/login-sso"),
  ssoCallback: path(ROOT_PATH, "/sso/callback"),
  /** Consent screen for AI apps connecting to RivetAI over MCP OAuth. */
  mcpOAuthConsent: path(ROOT_PATH, "/oauth/consent"),
  oauthCallback: path(ROOT_PATH, "/auth/oauth/callback"),
  resendEmail: path(ROOT_PATH, "/confirm_email"),
  verifyAccount: path(ROOT_PATH, "/verify_account"), // Legacy route (kept for backward compatibility with email links)
  emailVerification: path(ROOT_PATH, "/email/verification"), // New cleaner route
  forgotPassword: path(ROOT_PATH, "/forgot_password"),
  resetPassword: path(ROOT_PATH, "/reset_password"),
  login: path(ROOT_PATH, "/login"),
  cancelDeletion: path(ROOT_PATH, "/cancel-deletion"),
};

export const PATH_OTHER = {
  notFound: path(ROOT_PATH, "/404"),
};
